var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDemographic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 7.99611H9.5C9.22386 7.99611 9 7.77135 9 7.49409V1.4698C9 1.19254 9.22386 0.967773 9.5 0.967773C13.0899 0.967773 16 3.8897 16 7.49409C16 7.77135 15.7761 7.99611 15.5 7.99611ZM10 1.99433V6.99206H14.9776C14.7398 4.34281 12.6386 2.23307 10 1.99433Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 4.48194V10.0042H12.5C12.7761 10.0042 13 10.229 13 10.5062C13 14.1106 10.0899 17.0326 6.5 17.0326C2.91015 17.0326 0 14.1106 0 10.5062C0 6.90185 2.91015 3.97992 6.5 3.97992C6.77614 3.97992 7 4.20468 7 4.48194ZM6.5 11.0083C6.22386 11.0083 6 10.7835 6 10.5062V5.00648C3.19675 5.26012 1 7.6256 1 10.5062C1 13.5561 3.46243 16.0285 6.5 16.0285C9.36902 16.0285 11.725 13.8229 11.9776 11.0083H6.5Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemographic);
export default __webpack_public_path__ + "static/media/demographic.b12113e308398f88fbd63568e6724691.svg";
export { ForwardRef as ReactComponent };